import React from 'react';
import styled from '@emotion/styled';

const UnorderedList = styled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;
`;

const ListItem = styled.li`
  font-size: 0.75rem;
  font-weight: 600;
  color: #798699;
  margin-right: 1.5rem;
`;

interface Props {
  appVersion: string;
}

const FooterInfo = (props: Props) => {
  const year = new Date().getFullYear();
  const { appVersion } = props;
  return (
    <UnorderedList>
      <ListItem>Version: {appVersion}</ListItem>
      <ListItem>© {year} Dell Inc. All Rights Reserved</ListItem>
      <ListItem>Powered by Live Optics, a Dell Technology</ListItem>
    </UnorderedList>
  );
};

export default FooterInfo;
